"use client";

import { useEffect } from "react";
import { ErrorLogService, ErrorSeverity } from "@/services/errorLog";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    void ErrorLogService.logError(error, {
      component: "app/global-error.tsx",
      severity: ErrorSeverity.CRITICAL,
      extra_data: {
        digest: error.digest,
      },
    });
  }, [error]);

  return (
    <html lang="pt-BR">
      <body className="bg-white">
        <div className="min-h-screen flex items-center justify-center px-4">
          <div className="max-w-md w-full rounded-xl border border-red-200 bg-white p-6 text-center shadow-lg">
            <h1 className="text-xl font-bold text-red-700 mb-2">
              Erro inesperado
            </h1>
            <p className="text-sm text-slate-700 mb-5">
              Não foi possível carregar esta página com segurança.
            </p>
            <button
              type="button"
              onClick={reset}
              className="w-full rounded-lg px-4 py-2 text-white font-semibold bg-emerald-700 hover:bg-emerald-800 transition-colors"
            >
              Recarregar
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
